<template>
  <div>
    <el-row style="height: 60px">
      <el-col :span="24">
        <el-button type="primary" size="small" @click="showImport=true" style="margin-right: 10px">导入订单</el-button>

        <el-button type="primary" size="small" @click="refundAgree('')">批量同意退款</el-button>
        <span style="margin-left: 10px;font-size: 12px">验证码：</span>
        <el-input v-model="code" size="mini" style="width:120px;"></el-input>
        <el-button type="primary" size="small" @click="refundAgree(code)">二次确认退款</el-button>

        <el-button type="danger" size="small" @click="refundRefuse">批量拒绝退款</el-button>

      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table border :data="refundData"  style="font-size: 12px" :header-cell-style="{background:'#F2F6FC',color:'#000'}" :cell-style="{padding: '0px'}">
          <el-table-column  label="ID"
                            type="index"
                            :index="indexMethod">
          </el-table-column>
          <el-table-column  prop="tid" label="订单号" width="260px"></el-table-column>
          <el-table-column  prop="oid" label="子订单号（可选）" width="200px"></el-table-column>
          <el-table-column v-if="false" prop="refundFee" label="退款金额" width="200px"></el-table-column>
          <el-table-column  prop="status" label="状态" ></el-table-column>
        </el-table>
      </el-col>
    </el-row>

    <el-dialog
      title="导入订单" :close-on-click-modal="false"
      :visible.sync="showImport"
      width="50%"
      center>
      <span style="margin-left:20px; margin-bottom: 30px">复制Excel表格里的订单，在这里粘贴 （格式：订单号  延时天数） </span>
      <el-input :rows="15" type="textarea" v-model="refundTxt"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showImport = false">取 消</el-button>
        <el-button type="primary" @click="uploadData">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import $api from "../api/axios";
  import storage from "../api/storage"
  import cookies from "../api/cookie"
  import copy from "../api/copy"

    export default {
        name: "Refund",
      data(){
        return{
          deny:0,
          code:'',
          showImport:false,
          refundTxt:'',
          refundData:[],
          sendValue:'offline',
          sendOpto:[{label:'虚拟发货',value:'dummy'},{label:'自己联系',value:'offline'},{label:'线上物流',value:'online'}]

        }
      },
      methods:{
        indexMethod(index)
        {
          return index + 1;
        },
        getRefundData:function () {
          let param={
            nick:storage.get("nick"),
          }
          $api.post("/refund/get", param, response =>{
            let dataResult = response.data;
            if (dataResult.state == 1 && dataResult.message == "ok"){
              this.refundData = dataResult.data;
            }
            else{
              this.$message.error(dataResult);
              this.deny = 1;
            }
          })
        },
        uploadData:function () {
          this.showImport = false;
          if(this.deny == 1){
            this.$message.error("您没有该权限, 请联系主号分配权限。");
            return;
          }
          let param={
            nick:storage.get("nick"),
            txt: this.refundTxt
          }
          $api.post("/refund/import", param, response =>{
            console.log(response)
            let dataResult = response.data;
            if (dataResult.state == 1 && dataResult.message == "ok"){
              this.delayTxt = '';
              this.getRefundData();
              console.log("end.")
            }
            else{
              this.$message.error(dataResult);
            }
          })
        },
        refundAgree:function (code) {
          if(this.refundData.length == 0){
            this.$message.error("没有订单数据，请先导入订单后再操作！。");
            return;
          }
          if ((code != undefined) && (code != '')){
            if(this.code.length == 0){
              this.$message.error("请输入验证码");
              return;
            }else  if(!(/^\d{6}$/.test(this.code)) ){
              this.$message.error("验证码为6位数字，请检查");
              return;
            }
          }
          // if(this.deny == 1){
          //   this.$message.error("您没有该权限, 请联系主号分配权限。");
          //   return;
          // }
          let param={
            nick:storage.get("nick"),
            code: this.code,
          }
          $api.post("/refund/update", param, response =>{
            console.log(response)
            let dataResult = response.data;
            if (dataResult.state == 1 && dataResult.message == "ok"){

              this.getRefundData();
              this.$message.success("批量同意退款完成。")
            }
            else{
              this.$message.error(dataResult);
            }
          })
        },
        refundRefuse:function(){
          let param={
            nick:storage.get("nick")
          }
          $api.post("/refund/refuse", param, response =>{
            console.log(response)
            let dataResult = response.data;
            if (dataResult.state == 1 && dataResult.message == "ok"){

              this.getRefundData();
              this.$message.success("批量拒绝退款完成。")
            }
            else{
              this.$message.error(dataResult);
            }
          })
        }
      },
      mounted(){
        this.getRefundData();
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/Refund.vue